export default {
  // ==================================================================================
  // This part is for mapping product's category data from the dynamic router
  // ==================================================================================
  categoriesMap: {
    "kitchens": "kitchens",
    "baths": "baths",
    "countertops": "countertops",
  },
  kitchens: {
    categoryName: "Kitchen",
    bannerSection: {
      bannerImage: {
        desktop: "/images/products/kitchen/allKitchen/DSC_3179.jpg",
        ipad: "/images/products/kitchen/allKitchen/DSC_3179.jpg",
        mobile: "/images/products/kitchen/allKitchen/DSC_3179.jpg",
      },
    },
    contactForm: {
      title: "Schedule a FREE in-home consultation today!",
    },
    productsExplanationSection: {
      productDescription: {
        title: {
          desktop: {
            line1: "Classy Kitchens",
            line2: "",
          },
          ipad: {
            line1: "Classy Kitchens",
            line2: "",
          },
          mobile: {
            line1: "Classy Kitchens",
            line2: "",
          },
        },
        description:
          "Kitchens are the heart of the home, a place of gathering, a place where special life moments are shared. Let us help you design a beautiful, welcoming space that you can share with your loved ones for years to come.",
        actionButtonText: "VIEW CLOSETS",
      },
      productImageSlider: {
        desktop: [
          {
            id: 1,
            mainImgUrl: "/images/home_page/closets.jpg",
            smallImgUrl: "/images/home_page/closets.jpg",
          },
          {
            id: 2,
            mainImgUrl: "/images/home_page/homeoffice.jpg",
            smallImgUrl: "/images/home_page/homeoffice.jpg",
          },
          {
            id: 3,
            mainImgUrl: "/images/home_page/laundryroom.jpg",
            smallImgUrl: "/images/home_page/laundryroom.jpg",
          },
          {
            id: 4,
            mainImgUrl: "/images/home_page/pantries.jpg",
            smallImgUrl: "/images/home_page/pantries.jpg",
          },
        ],
        ipad: [],
        mobile: [],
      },
    },
    stepsSection: true,
    categorySection: {
      desktop: [
        {
          id: 1,
          title: "LUXURY",
          imgSrc: "/images/closets/category1.png",
          url: "/products/luxury-closets",
        },
        {
          id: 2,
          title: "WALK-IN",
          imgSrc: "/images/closets/category2.png",
          url: "/products/walk-in-closets",
        },
        {
          id: 3,
          title: "REACH-IN",
          imgSrc: "/images/closets/category3.png",
          url: "/products/reach-in-closets",
        },
        {
          id: 4,
          title: "KIDS",
          imgSrc: "/images/closets/category4.png",
          url: "/products/kids-closets",
        },
      ],
      ipad: [],
      mobile: [],
    },
    reviewsSection: {
      title: "What our customers are saying:",
      coverImg: {
        desktop: "/images/products/kitchen/review-banner.jpg",
        ipad: "/images/products/kitchen/review-banner.jpg",
        mobile: "/images/products/kitchen/review-banner.jpg",
      },
    },
    productsAndServiceSection: {
      title: "Our Products & Services",
      data: [
        {
          id: 1,
          type: "service",
          title: "KITCHENS",
          imgSrc: "/images/home_page/closets.jpg",
          contentTitle: "",
          content: "",
          btnText: "Learn More",
          url: "/products/kitchens",
        },
        {
          id: 2,
          type: "service",
          title: "BATHS",
          imgSrc: "/images/home_page/homeoffice.jpg",
          contentTitle: "",
          content: "",
          btnText: "Learn More",
          url: "/products/baths",
        },
        {
          id: 3,
          type: "service",
          title: "COUNTERS",
          imgSrc: "/images/home_page/laundryroom.jpg",
          contentTitle: "",
          content: "",
          btnText: "Learn More",
          url: "/products/counters",
        },
        {
          id: 5,
          type: "service",
          title: "VIEW ALL",
          imgSrc: "/images/home_page/viewall.jpg",
          contentTitle: "",
          content: "",
          btnText: "Learn More",
          url: "/products/closets",
        },
      ],
    },
    allPhotos: [
      {
        "src": "/images/products/kitchen/allKitchen/kitchen-1.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/kitchen-2.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/kitchen-3.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/kitchen-4.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/kitchen-5.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/kitchen-6.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/kitchen-7.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/kitchen-8.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/kitchen-9.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/kitchen-10.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/kitchen-11.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/kitchen-12.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/kitchen-13.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/kitchen-14.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_2429.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_2431.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_2432.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_2433.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_3179.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_3183.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_3186.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_3188.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_3191.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_3193.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_3196.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_3201.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_3204.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_3206.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_3210.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_3211.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_3212.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_3213.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_3221.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_3233.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_6829.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_9134.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_9135.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_9141.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_9144.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_9156.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_9159.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_9164.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_9165.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_9166.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_9167.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_9168.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/DSC_9170.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/Mtn-14.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/Mtn-15.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/Mtn-16.jpg",
        "alt": "example of custom kitchen work"
      },
      {
        "src": "/images/products/kitchen/allKitchen/Mtn-19.jpg",
        "alt": "example of custom kitchen work"
      }
    ]
  },
  baths: {
    categoryName: "Bath",
    bannerSection: {
      bannerImage: {
        desktop: "/images/products/baths/1-Featured.webp",
        ipad: "/images/products/baths/1-Featured.webp",
        mobile: "/images/products/baths/1-Featured.webp",
      },
    },
    contactForm: {
      title: "Schedule a FREE in-home consultation today!",
    },
    productsExplanationSection: {
      productDescription: {
        title: {
          desktop: {
            line1: "Classy Baths",
            line2: "",
          },
          ipad: {
            line1: "Classy Baths",
            line2: "",
          },
          mobile: {
            line1: "Classy Baths",
            line2: "",
          },
        },
        description:
          "Your bathroom should be an oasis. We can help create a place of peace and relaxation that will only help you start and end your days the right way.",
        actionButtonText: "VIEW CLOSETS",
      },
      productImageSlider: {
        desktop: [
          {
            id: 1,
            mainImgUrl: "/images/home_page/closets.jpg",
            smallImgUrl: "/images/home_page/closets.jpg",
          },
          {
            id: 2,
            mainImgUrl: "/images/home_page/homeoffice.jpg",
            smallImgUrl: "/images/home_page/homeoffice.jpg",
          },
          {
            id: 3,
            mainImgUrl: "/images/home_page/laundryroom.jpg",
            smallImgUrl: "/images/home_page/laundryroom.jpg",
          },
          {
            id: 4,
            mainImgUrl: "/images/home_page/pantries.jpg",
            smallImgUrl: "/images/home_page/pantries.jpg",
          },
        ],
        ipad: [],
        mobile: [],
      },
    },
    stepsSection: true,
    categorySection: {
      desktop: [
        {
          id: 1,
          title: "LUXURY",
          imgSrc: "/images/closets/category1.png",
          url: "/products/luxury-closets",
        },
        {
          id: 2,
          title: "WALK-IN",
          imgSrc: "/images/closets/category2.png",
          url: "/products/walk-in-closets",
        },
        {
          id: 3,
          title: "REACH-IN",
          imgSrc: "/images/closets/category3.png",
          url: "/products/reach-in-closets",
        },
        {
          id: 4,
          title: "KIDS",
          imgSrc: "/images/closets/category4.png",
          url: "/products/kids-closets",
        },
      ],
      ipad: [],
      mobile: [],
    },
    reviewsSection: {
      title: "What our customers are saying:",
      coverImg: {
        desktop: "/images/products/baths/allBaths/Mtn-2.jpg",
        ipad: "/images/products/baths/allBaths/Mtn-2.jpg",
        mobile: "/images/products/baths/allBaths/Mtn-2.jpg",
      },
    },
    productsAndServiceSection: {
      title: "Our Products & Services",
      data: [
        {
          id: 1,
          type: "service",
          title: "KITCHENS",
          imgSrc: "/images/home_page/closets.jpg",
          contentTitle: "",
          content: "",
          btnText: "Learn More",
          url: "/products/kitchens",
        },
        {
          id: 2,
          type: "service",
          title: "BATHS",
          imgSrc: "/images/home_page/homeoffice.jpg",
          contentTitle: "",
          content: "",
          btnText: "Learn More",
          url: "/products/baths",
        },
        {
          id: 3,
          type: "service",
          title: "COUNTERS",
          imgSrc: "/images/home_page/laundryroom.jpg",
          contentTitle: "",
          content: "",
          btnText: "Learn More",
          url: "/products/counters",
        },
        {
          id: 5,
          type: "service",
          title: "VIEW ALL",
          imgSrc: "/images/home_page/viewall.jpg",
          contentTitle: "",
          content: "",
          btnText: "Learn More",
          url: "/products/closets",
        },
      ],
    },
    allPhotos: [
      {
        "src": "/images/products/baths/allBaths/bath-1.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/bath-2.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/bath-3.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/bath-4.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/bath-5.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/bath-6.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/bath-7.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/bath-8.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/bath-9.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/bath-10.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/bath-11.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/bath-12.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/bath-13.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/bath-14.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/bath-15.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/bath-16.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/DSC_6407.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/DSC_6409.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/DSC_6410.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/DSC_6412.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/DSC_6415.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/DSC_6416.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/DSC_6417.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/DSC_6419.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/DSC_6876.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/DSC_6878.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/DSC_6880.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/DSC_6881.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/DSC_9325.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/DSC_9326.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/DSC_9328.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/DSC_9332.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/DSC_9335.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/DSC_9340.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/DSC_9349.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/DSC_9359.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/Mtn-1.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/Mtn-2.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/Mtn-3.jpg",
        "alt": "example of custom bath work"
      },
      {
        "src": "/images/products/baths/allBaths/Mtn-4.jpg",
        "alt": "example of custom bath work"
      }
    ]
  },
  countertops: {
    categoryName: "Countertops",
    bannerSection: {
      bannerImage: {
        desktop: "/images/products/countertops/allCountertops/1 Gray Milano Door Kitchen.jpeg",
        ipad: "/images/products/countertops/allCountertops/1 Gray Milano Door Kitchen.jpeg",
        mobile: "/images/products/countertops/allCountertops/1 Gray Milano Door Kitchen.jpeg",
      },
    },
    contactForm: {
      title: "Schedule a FREE in-home consultation today!",
    },
    productsExplanationSection: {
      productDescription: {
        title: {
          desktop: {
            line1: "Classy Countertops",
            line2: "",
          },
          ipad: {
            line1: "Classy Countertops",
            line2: "",
          },
          mobile: {
            line1: "Classy Countertops",
            line2: "",
          },
        },
        description:
          "Let your countertop be like the icing on a cake. We have great styles and designs to choose from that will complete any kitchen or bath project you have!",
        actionButtonText: "VIEW CLOSETS",
      },
      productImageSlider: {
        desktop: [
          {
            id: 1,
            mainImgUrl: "/images/home_page/closets.jpg",
            smallImgUrl: "/images/home_page/closets.jpg",
          },
          {
            id: 2,
            mainImgUrl: "/images/home_page/homeoffice.jpg",
            smallImgUrl: "/images/home_page/homeoffice.jpg",
          },
          {
            id: 3,
            mainImgUrl: "/images/home_page/laundryroom.jpg",
            smallImgUrl: "/images/home_page/laundryroom.jpg",
          },
          {
            id: 4,
            mainImgUrl: "/images/home_page/pantries.jpg",
            smallImgUrl: "/images/home_page/pantries.jpg",
          },
        ],
        ipad: [],
        mobile: [],
      },
    },
    stepsSection: true,
    categorySection: {
      desktop: [
        {
          id: 1,
          title: "LUXURY",
          imgSrc: "/images/closets/category1.png",
          url: "/products/luxury-closets",
        },
        {
          id: 2,
          title: "WALK-IN",
          imgSrc: "/images/closets/category2.png",
          url: "/products/walk-in-closets",
        },
        {
          id: 3,
          title: "REACH-IN",
          imgSrc: "/images/closets/category3.png",
          url: "/products/reach-in-closets",
        },
        {
          id: 4,
          title: "KIDS",
          imgSrc: "/images/closets/category4.png",
          url: "/products/kids-closets",
        },
      ],
      ipad: [],
      mobile: [],
    },
    reviewsSection: {
      title: "What our customers are saying:",
      coverImg: {
        desktop: "/images/products/countertops/allCountertops/3 Cambria Brittanica.jpeg",
        ipad: "/images/products/countertops/allCountertops/3 Cambria Brittanica.jpeg",
        mobile: "/images/products/countertops/allCountertops/3 Cambria Brittanica.jpeg",
      },
    },
    productsAndServiceSection: {
      title: "Our Products & Services",
      data: [
        {
          id: 1,
          type: "service",
          title: "KITCHENS",
          imgSrc: "/images/home_page/closets.jpg",
          contentTitle: "",
          content: "",
          btnText: "Learn More",
          url: "/products/kitchens",
        },
        {
          id: 2,
          type: "service",
          title: "BATHS",
          imgSrc: "/images/home_page/homeoffice.jpg",
          contentTitle: "",
          content: "",
          btnText: "Learn More",
          url: "/products/baths",
        },
        {
          id: 3,
          type: "service",
          title: "COUNTERS",
          imgSrc: "/images/home_page/laundryroom.jpg",
          contentTitle: "",
          content: "",
          btnText: "Learn More",
          url: "/products/counters",
        },
        {
          id: 5,
          type: "service",
          title: "VIEW ALL",
          imgSrc: "/images/home_page/viewall.jpg",
          contentTitle: "",
          content: "",
          btnText: "Learn More",
          url: "/products/closets",
        },
      ],
    },
    allPhotos: [
      {
        "src": "/images/products/countertops/allCountertops/DSC_0444-min.jpg",
        "alt": "example of custom countertop work"
      },
      {
        "src": "/images/products/countertops/allCountertops/DSC_3193-min.jpg",
        "alt": "example of custom countertop work"
      },
      {
        "src": "/images/products/countertops/allCountertops/DSC_3211-min.jpg",
        "alt": "example of custom countertop work"
      },
      {
        "src": "/images/products/countertops/allCountertops/DSC_3249-min.jpg",
        "alt": "example of custom countertop work"
      },
      {
        "src": "/images/products/countertops/allCountertops/DSC_5630-min.jpg",
        "alt": "example of custom countertop work"
      },
      {
        "src": "/images/products/countertops/allCountertops/DSC_6374-min.jpg",
        "alt": "example of custom countertop work"
      },
      {
        "src": "/images/products/countertops/allCountertops/DSC_6814-min.jpg",
        "alt": "example of custom countertop work"
      },
      {
        "src": "/images/products/countertops/allCountertops/DSC_9156-min.jpg",
        "alt": "example of custom countertop work"
      }
    ]
  },
};
